import Search from  '@/components/page/Search';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';


class SearchPortal extends Component {
  render() {
    let appName: string
    // Container ref
    let targetContainer = document.getElementById('react-search-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }
    else {
        appName = targetContainer.getAttribute('data-app-name');
    }

    return ReactDOM.createPortal(
      <Search appName={appName}/>, targetContainer
    );
  }
}

export default SearchPortal;